import {
  FunctionButton,
  PrimaryButton,
  SecondaryButton,
} from '@pulse-web-ui/button-v2';
import { styled } from '@pulse-web-ui/theme';

export const PageBackButton = styled(FunctionButton)`
  margin-bottom: 16px;
`;

export const IconButton = styled.div<{ $isPrimary?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: ${({ theme }) => theme.common.radius};
  background: ${({ theme, $isPrimary }) =>
    $isPrimary
      ? theme.colors.surface.primary
      : theme.colors.surface.background};
  cursor: pointer;
  flex-shrink: 0;
`;

export const FullWidthPrimaryButton = styled(PrimaryButton)`
  width: 100%;
`;
export const SubmitPrimaryButton = styled(PrimaryButton)`
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.common.radiusM};
`;

export const FullWidthSecondaryButton = styled(SecondaryButton)`
  width: 100%;
  min-height: 48px;
  height: auto;
  padding-top: 4px;
  padding-bottom: 4px;

  & svg {
    flex-shrink: 0;
  }
`;
